
import * as ipxStaticRuntime$_6Fb_455vF_o20krpR_ZkxeaFU_457hDGknyFjMivxPclZp0 from '/var/lib/jenkins/workspace/avia73.pro/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'

export const imageOptions = {
  "screens": {
    "xs": 359,
    "sm": 639,
    "md": 767,
    "lg": 1023,
    "xl": 1239,
    "xxl": 1439,
    "2xl": 1559
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "avif",
    "png",
    "jpg",
    "webp"
  ]
}

imageOptions.providers = {
  ['ipxStatic']: { provider: ipxStaticRuntime$_6Fb_455vF_o20krpR_ZkxeaFU_457hDGknyFjMivxPclZp0, defaults: {} }
}
        